import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import React, { useEffect, useMemo, useState } from "react";
import { InstagramItemsStatic } from "../../InstagramItemsStatic";
var appId = process.env.FACEBOOK_APP_ID;
var clientToken = process.env.FACEBOOK_CLIENT_TOKEN;
var clientAccessToken = "".concat(appId, "|").concat(clientToken);

var getInstagramEmbed =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(url) {
    var response, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch("https://graph.facebook.com/v9.0/instagram_oembed?url=".concat(url, "&fields=thumbnail_url,author_name&access_token=").concat(clientAccessToken));

          case 3:
            response = _context.sent;

            if (!response.ok) {
              _context.next = 9;
              break;
            }

            _context.next = 7;
            return response.json();

          case 7:
            data = _context.sent;
            return _context.abrupt("return", _objectSpread({}, data, {
              url: url
            }));

          case 9:
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            console.error("error: ", _context.t0);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));

  return function getInstagramEmbed(_x) {
    return _ref.apply(this, arguments);
  };
}();

export function InstagramItemsEmbedThumbnail(_ref2) {
  var postUrls = _ref2.postUrls;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      embedPosts = _useState2[0],
      setEmbedPosts = _useState2[1];

  useEffect(function () {
    if (postUrls) {
      var getInstagramEmbedPosts =
      /*#__PURE__*/
      function () {
        var _ref3 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2() {
          var postsData, filteredPostData;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return Promise.all(postUrls.map(getInstagramEmbed));

                case 2:
                  postsData = _context2.sent;
                  filteredPostData = [];
                  postsData.forEach(function (post) {
                    if (post) {
                      filteredPostData.push(post);
                    }
                  });
                  setEmbedPosts(filteredPostData);

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function getInstagramEmbedPosts() {
          return _ref3.apply(this, arguments);
        };
      }();

      getInstagramEmbedPosts();
    }
  }, [postUrls]);
  var instagramStaticItems = useMemo(function () {
    return embedPosts.map(function (post) {
      return {
        image: {
          url: post.thumbnail_url
        },
        instagram_link: {
          url: post.url
        },
        post_user_name: "@".concat(post.author_name)
      };
    });
  }, [embedPosts]);
  return React.createElement(InstagramItemsStatic, {
    items: instagramStaticItems
  });
}